import {FC} from 'react'
import { Company } from '../../core/_models'

type Props = {
  company: Company
}

const CompanyIdCell: FC<Props> = ({company}) => {
  return (
    <>
      {
        <div className='d-flex align-items-center'>
        <div className='d-flex flex-column'>
            {company.id}
        </div>
      </div>
      }
    </>
  )
}

export {CompanyIdCell}
